import { render, staticRenderFns } from "./v-pagination.vue?vue&type=template&id=56c9c115"
import script from "./v-pagination.vue?vue&type=script&lang=js"
export * from "./v-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c9c115')) {
      api.createRecord('56c9c115', component.options)
    } else {
      api.reload('56c9c115', component.options)
    }
    module.hot.accept("./v-pagination.vue?vue&type=template&id=56c9c115", function () {
      api.rerender('56c9c115', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/pagination/v-pagination.vue"
export default component.exports